/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Newspage_IntroInputs */

const en_fw_newspage_intro = /** @type {(inputs: Fw_Newspage_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A running timeline of Firefly Wedding anime and manga news, from the first announcement to this week.`)
};

const zh_fw_newspage_intro = /** @type {(inputs: Fw_Newspage_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从首次公布到本周，萤火之嫁动画与漫画消息的完整时间线。`)
};

/**
* | output |
* | --- |
* | "A running timeline of Firefly Wedding anime and manga news, from the first announcement to this week." |
*
* @param {Fw_Newspage_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_newspage_intro = /** @type {((inputs?: Fw_Newspage_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Newspage_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_newspage_intro(inputs)
	return zh_fw_newspage_intro(inputs)
});
export { fw_newspage_intro as "fw.newspage.intro" }